import { c as _c } from "react/compiler-runtime";
// Срок задачи: пресеты, которыми менеджер ставит «следующий шаг» в одно
// касание, и своя дата со временем для остального.
import { Input } from "@osmix/ui/input";
import { useState } from "react";
import { Chip } from "./ui";
import { fromLocalInput, toLocalInput } from "./format";
type Preset = "today" | "tomorrow" | "in3" | "week";
const at = (days: number, hours: number) => {
  const date = new Date();
  date.setDate(date.getDate() + days);
  date.setHours(hours, 0, 0, 0);
  return date;
};

/**
 * «Сегодня» — до конца рабочего дня (18:00); если он уже почти кончился —
 * через час, округлённо до получаса, чтобы задача не родилась просроченной.
 */
const presetDate = (preset: Preset): Date => {
  if (preset === "today") {
    const evening = at(0, 18);
    if (evening.getTime() - Date.now() > 30 * 60_000) return evening;
    const soon = new Date(Date.now() + 60 * 60_000);
    soon.setMinutes(soon.getMinutes() < 30 ? 30 : 60, 0, 0);
    return soon;
  }
  if (preset === "tomorrow") return at(1, 10);
  if (preset === "in3") return at(3, 10);
  return at(7, 10);
};
export const presetDue = (preset: Preset) => presetDate(preset).toISOString();
const PRESETS: {
  value: Preset;
  label: string;
}[] = [{
  value: "today",
  label: "Сегодня"
}, {
  value: "tomorrow",
  label: "Завтра"
}, {
  value: "in3",
  label: "Через 3 дня"
}, {
  value: "week",
  label: "Через неделю"
}];
export function DuePicker(t0) {
  const $ = _c(19);
  const {
    value,
    onChange,
    initialPreset: t1,
    disabled
  } = t0;
  const initialPreset = t1 === undefined ? "tomorrow" : t1;
  const [mode, setMode] = useState(initialPreset);
  let t2;
  if ($[0] !== disabled || $[1] !== mode || $[2] !== onChange) {
    t2 = PRESETS.map(preset => <Chip key={preset.value} active={mode === preset.value} disabled={disabled} className="px-2.5 text-xs" onClick={() => {
      setMode(preset.value);
      onChange(presetDue(preset.value));
    }}>{preset.label}</Chip>);
    $[0] = disabled;
    $[1] = mode;
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = mode === "custom";
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setMode("custom");
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== disabled || $[6] !== t3) {
    t5 = <Chip active={t3} disabled={disabled} className="px-2.5 text-xs" onClick={t4}>Своя дата</Chip>;
    $[5] = disabled;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <div className="flex flex-wrap gap-1.5" role="group" aria-label={"\u0421\u0440\u043E\u043A"}>{t2}{t5}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== disabled || $[12] !== mode || $[13] !== onChange || $[14] !== value) {
    t7 = mode === "custom" && <Input type="datetime-local" aria-label={"\u0421\u0440\u043E\u043A: \u0434\u0430\u0442\u0430 \u0438 \u0432\u0440\u0435\u043C\u044F"} className="h-8 w-full sm:w-56" disabled={disabled} value={toLocalInput(value)} onChange={e => onChange(fromLocalInput(e.target.value))} />;
    $[11] = disabled;
    $[12] = mode;
    $[13] = onChange;
    $[14] = value;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="flex flex-col gap-2">{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}